import AccountPage from '../components/Account/Account';

export default function Account() {
  return <AccountPage />;
}
